if($('.type-detail').length && $('.product-top .flag-moznost-konfigurace').length){
    if($('.admin-logged').length){
        $('.p-detail-tabs-wrapper').prepend('<div class="customSurcahrgeTable"><h3>Nápověda ke konfigurátoru</h3>Formát souborů musí být vždy .jpg a umístěno do složky konfigurator do správce souborů. První část je název příplatku a druhá je název souboru. Složku konfigurátor je třeba rozpadnout dle složek. Název souboru vkládejte bez pomlčky<div class="inner"></div></div>')
    }
    $('.add-to-cart').hide()
    $('.p-info-wrapper').append('<div class="configurationButton"><span class="btn btn-primary">'+buttonText+'</span></div>')
    var customConfig = '<div class="customConfig">'
        customConfig += '<span class="close"></span>'
        customConfig += '<div class="configTopLine">'
            customConfig += '<h2>'+nadpisKonfiguratoru+'</h2>'
            customConfig += '<p>'+popisKonfiguratoru+'</p>'
        customConfig += '</div>'
        customConfig += '<div class="configCenterLine"></div>'
        customConfig += '<div class="configBottomLine">'
            customConfig += '<div class="p-final-price-wrapper">'+$('.p-info-wrapper .p-final-price-wrapper').html()+'</div>'
            customConfig += '<div class="add-to-cart">'+$('.p-info-wrapper .add-to-cart').html()+'</div>'
        customConfig += '</div>'
    customConfig += '</div>'
    $('.p-info-wrapper>.add-to-cart').remove();
    $('.p-info-wrapper').append(customConfig)
    $('.variant-list').each(function(){
        $(this).hide()
        $(this).find('select').attr("required", "required")
        var selectName = $(this).find('select').data('parameter-name')
        var selectID = $(this).find('select').data('parameter-id')
        var variantProductList = '<div class="variantRow">'
            if($(this).find('select').length){
                
                variantProductList += '<h3>'+selectName+'<span class="choosen"></span></h3>'
            }
            variantProductList += '<div class="chooseRow">'
            $(this).find('select option').each(function(){
                if ($.isNumeric($(this).attr('value'))){
                    var optionText = $(this).text()
                    
                    variantProductList += '<div class="parameterInner variant" data-has-multiple="no" data-title-name="'+selectName+'" data-select-id="'+selectID+'" data-option-id="'+$(this).attr('value')+'">'
                        variantProductList += '<span class="textWrap">'
                            variantProductList += '<span class="name">'+optionText+'</span>'
                            variantProductList += '<span class="btn btn-default">Vybrat</span>'
                        variantProductList += '</span>'
                    variantProductList += '</div>'
                }
            })
            variantProductList += '</div>'
        variantProductList += '</div>'
        $('.customConfig .configCenterLine').append(variantProductList)
        
    })
    $('.surcharge-list').each(function(){
        $(this).hide()
        $(this).find('select').attr("required", "required")
        var selectID = $(this).find('select').data('parameter-id')
        var selectName = $(this).find('select').data('parameter-name')
        var found = false; // Příznak pro zjištění, zda byla nalezena odpovídající konfigurace

$.each(skupinyKonfigurace, function(key, konfig) {
        if($.inArray(selectID.toString(), konfig.ids) !== -1) {
            found = true; // Nalezena konfigurace
            var customClass = konfig.class;
            var nadpis = konfig.nadpis;
           
            // Kontrola, zda již existuje element pro tuto skupinu
   
            if($('.customConfig .configCenterLine .' + customClass).length < 1){
                
                $('.customConfig .configCenterLine').append('<div class="variantRowGroup ' + customClass + '"><h3>'+nadpis+'<span class="choosen"></span></h3><ul class="groupNavigation"></ul></div>');
            }

            // Přidání požadavku na vyžadovaný a skupinový atribut
            $(this).find('select').attr("required", "required").attr('data-group', 'yes');
            var sanitizedSelectName = selectName.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(/\s+/g, '-');
            var variantProductList = '<div class="variantRow have-group" data-parameter-group="'+sanitizedSelectName+'"><div class="chooseRow">';

            // Iterace přes všechny možnosti a vytvoření HTML pro každou variantu
            $(this).find('select option').each(function(){
                var optionValue = $(this).attr('value');
                if ($.isNumeric(optionValue)){
                    var optionText = $(this).text().split('+')[0].trim();
                    var optionPrice = $(this).text().split('+')[1];
                    if(optionPrice === '0 Kč'){
                        optionPrice = 'Bez doplatku'
                    }
                    else{
                        optionPrice = optionPrice
                    }
                    var placeholderImage = '/user/documents/upload/konfigurator/noImage.png';
                    variantProductList += '<div class="parameterInner surcharge" data-has-multiple="multiple" data-title-name="'+selectName+'" data-select-id="'+selectID+'" data-option-id="'+optionValue+'">'+
                                          '<i class="lupa"></i><span class="image"><img src="/user/documents/upload/konfigurator/'+sanitizedSelectName+'/'+optionValue+'.jpg" alt="'+optionText+'" onerror="this.onerror=null;this.src=\''+placeholderImage+'\';"></span>'+
                                          '<span class="textWrap">'+
                                            '<span class="name">'+optionText+'</span>'+
                                            '<span class="price">'+optionPrice+'</span>'+
                                            '<span class="btn btn-default">Vybrat</span>'+
                                          '</span>'+
                                       '</div>';
                                       var customTable = '<div><p class="left"><strong>'+$(this).text().split('+')[0].trim()+'</strong></p> <p>Název skupiny: '+selectName+'</p><p class="right">Název souboru: '+$(this).attr('value')+'</p> <p>Složka: '+selectName.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(/\s+/g, '-')+'</p></div>'
                                       $('.customSurcahrgeTable .inner').append(customTable)
                }
            });

            variantProductList += '</div></div>';
            $('.customConfig .configCenterLine .' + customClass).append(variantProductList);

            // Přidání navigace
            if($(this).find('th span.question-tooltip').length){
                $('.customConfig .' + customClass + ' ul').append('<li data-parameter-name="'+sanitizedSelectName+'">'+selectName+' <span class="show-tooltip question-tooltip" title="'+$(this).find('th span.question-tooltip').attr('title')+'">?</span></li>');
            } else {
                $('.customConfig .' + customClass + ' ul').append('<li data-parameter-name="'+sanitizedSelectName+'">'+selectName+'</li>');
            }

            // Aktivace první varianty a navigace
            $('.customConfig .' + customClass + ' .variantRow').first().addClass('active-group');
            $('.customConfig .' + customClass + ' .groupNavigation li').first().addClass('active-group');
            return false; // Ukončení cyklu, protože jsme našli a zpracovali konfiguraci
        }
    }.bind(this)); // Použití .bind(this) pro zachování kontextu

         if(!found){
            var variantProductList = '<div class="variantRow">'
            var selectID = $(this).find('select').data('parameter-id')
            if($(this).find('th span.question-tooltip').length){
                variantProductList += '<h3>'+$(this).find('select').data('parameter-name')+' <span class="show-tooltip question-tooltip" title="'+$(this).find('th span.question-tooltip').attr('title')+'" data-original-title="">?</span><span class="choosen"></span></h3>'
            }
            else{
                variantProductList += '<h3>'+$(this).find('select').data('parameter-name')+'<span class="choosen"></span></h3>'
            }
            variantProductList += '<div class="chooseRow">'
            $(this).find('select option').each(function(){
                var optionValue = $(this).attr('value')
                if ($.isNumeric(optionValue)){
                    var optionText = $(this).text().split('+')[0]
                    var optionprice = $(this).text().split('+')[1]
                    if(optionprice === '0 Kč'){
                        optionprice = 'Bez doplatku'
                    }
                    else{
                        optionprice = optionprice
                    }
                    var placeholderImage = '/user/documents/upload/konfigurator/noImage.png';
                    variantProductList += '<div class="parameterInner surcharge" data-has-multiple="no" data-title-name="'+selectName+'" data-select-id="'+selectID+'" data-option-id="'+$(this).attr('value')+'">'
                    variantProductList += '<i class="lupa"></i><span class="image"><img src="/user/documents/upload/konfigurator/'+selectName.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(/\s+/g, '-')+'/'+optionValue+'.jpg" alt="'+$(this).text().trim()+'" onerror="this.onerror=null;this.src=\''+placeholderImage+'\';"></span>'
                        variantProductList += '<span class="textWrap">'
                            variantProductList += '<span class="name">'+optionText+'</span>'
                            variantProductList += '<span class="price">'+optionprice+'</span>'
                            variantProductList += '<span class="btn btn-default">Vybrat</span>'
                        variantProductList += '</span>'
                    variantProductList += '</div>'
                    var customTable = '<div><p class="left"><strong>'+$(this).text().split('+')[0].trim()+'</strong></p> <p>Název skupiny: '+selectName+'</p><p class="right">Název souboru: '+$(this).attr('value')+'</p> <p>Složka: '+selectName.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(/\s+/g, '-')+'</p></div>'
                    $('.customSurcahrgeTable .inner').append(customTable)
                }
            })
            variantProductList += '</div>'
            variantProductList += '</div>'
            $('.customConfig .configCenterLine').append(variantProductList)   
        }
    })
    $(document).ready(function() {
        function moveVariantRows() {
            $(".variantRow").each(function() {
                var parameterGroup = $(this).attr("data-parameter-group");
                var matchingLi = $(".groupNavigation li[data-parameter-name='" + parameterGroup + "']");
                if (matchingLi.length > 0) {
                    $(this).closest('ul').insertAfter(matchingLi);
                }
            });
        }
        $(window).on('load resize', function() {
            if ($(window).width() < 768) {
                moveVariantRows();
            }
        });
    });
}
$('.lupa').each(function() {
    var image = $(this).closest('.parameterInner').find('.image img');
    var src = image.attr('src');
    var bigSrc = src.split('.jpg')[0] + '_big.jpg';
    var img = new Image();
    img.onload = () => {
        $(this).attr('data-big', bigSrc);
    };
    img.onerror = () => {
        $(this).remove();
    };
    img.src = bigSrc;
});

$(document).on('click', '.lupa', function(e){
    e.preventDefault();
    $.colorbox({
        html: '<img src="' + $(this).attr('data-big') + '" style="max-width: 100%;max-height: 100%;width: 100%;">',
        width: 440, // Procentuální šířka
        height: 440, // Procentuální výška
        maxWidth: "90%", // Maximální šířka
        maxHeight: "90%", // Maximální výška
        className: "colorBoxCustomImage",
        onComplete: function() {
            $('body').addClass('colorboxLatka')
        },
        onClosed: function(){
            $('body').removeClass('colorboxLatka')
        }
    });
});

$(document).on('click', '.groupNavigation li', function(){
    $(this).closest('.variantRowGroup').find('li').removeClass('active-group')
    $(this).addClass('active-group')
    $(this).closest('.variantRowGroup').find('.variantRow').removeClass('active-group')
    $(this).closest('.variantRowGroup').find('.variantRow[data-parameter-group="'+$(this).attr('data-parameter-name')+'"]').addClass('active-group')
})

$(document).on('click', '.configurationButton span', function(){
    $('body').addClass('configDisplay');
})

$(document).on('click', '.customConfig span.close', function(){
    $('body').removeClass('configDisplay');
})


$(document).on('click', '.parameterInner>span', function(){
    const variantData = $(this).closest('.parameterInner').attr('data-option-id').toString()
    const variantParameterId = $(this).closest('.parameterInner').attr('data-select-id').toString()
    const selectName = $(this).closest('.parameterInner').attr('data-title-name').trim()
    if($(this).closest('.parameterInner').data('has-multiple') === "multiple"){
        var selector = '.variant-list .hidden-split-parameter, .variant-list .split-parameter';
        var $splitParameters = $(selector);
        $splitParameters.trigger('change');
        $(".product-top .detail-parameters select[data-parameter-id='"+variantParameterId+"'] option").filter(function (){return $(this).attr('value') == variantData }).change().prop("selected", true)
       // $(this).closest('.chooseRow').find(".parameterInner:not([data-select-id='"+variantParameterId+"']):not([data-option-id='"+variantData+"'])").removeClass("active");
        //$(this).addClass("active"); 
      
        if($(this).closest('.parameterInner').find('img').length){
      
            var displayChoose = '<img src="'+$(this).closest('.parameterInner').find('img').attr('src')+'" alt="'+$(this).closest('.parameterInner').find('.textWrap span.name')+'">'
        }
        else{
            var displayChoose = ''
        }
        displayChoose += '<span class="textWrap">'+$(this).closest('.parameterInner').find('.textWrap').html()+'</span>'
        $(this).closest('.variantRowGroup').find('h3 span.choosen').html(displayChoose)
        $(this).closest('.variantRowGroup').find('.parameterInner').not($(this)).removeClass('active');
        //$(this).closest('.chooseRow').find(".parameterInner:not([data-select-id='"+variantParameterId+"']):not([data-option-id='"+variantData+"'])").removeClass("active");
        
        $(this).addClass("active");
        $(this).closest('.variantRowGroup').addClass('selected');
        $(this).closest('.variantRow').removeClass('openIt')
        $(this).closest('.variantRowGroup').removeClass('openIt')
        $(this).closest('.variantRowGroup').find('.groupNavigation li .choise').remove()
        $(this).closest('.variantRowGroup').find('.groupNavigation li[data-parameter-name="'+$(this).closest('.variantRow').attr('data-parameter-group')+'"]').addClass('selected').append('<span class="choise">Vybráno</span>')
        //$('ul li[data-parameter-name="'+$(this).closest('.variantRowGroup').find('.groupNavigation li').attr('data-parameter-group')+'"] .choise').remove()
        
        $(".product-top .detail-parameters select[data-parameter-id='"+variantParameterId+"']")[0].dispatchEvent(new Event('change'));
        /*
        if ($(this).attr('data-select-id').toString() !== variantParameterId) {
            $(this).find('option').first().change().prop("selected", true)
            $(this).removeAttr("required")
            const firstOption = $(this)[0];
            if (firstOption) {
                firstOption.dispatchEvent(new Event('change'));
            }
        }
        else{
            $(this).attr("required", "required")
        }*/
        var clickedSelectId = $(this).closest('.parameterInner').attr('data-select-id').toString(); // Získání ID kliknutého elementu jako string
        var relevantConfig = null; // Objekt pro uchování relevantní konfigurace

        // Zjistíme, zda se ID nachází v některé z konfigurací
        $.each(skupinyKonfigurace, function(key, konfig) {
            if (konfig.ids.includes(clickedSelectId)) {
                relevantConfig = konfig; // Uložíme konfiguraci, pokud byla nalezena
                return false; // Přerušíme cyklus, protože jsme našli odpovídající konfiguraci
            }
        });

        // Pokud jsme našli relevantní konfiguraci
        if (relevantConfig) {
            // Procházíme všechny select elementy na stránce
            $("select[data-parameter-id]").each(function() {
                var parameterId = $(this).attr('data-parameter-id').toString();
                // Pokud je select součástí relevantní skupiny a není to ten, na který bylo kliknuto
                if (relevantConfig.ids.includes(parameterId) && parameterId !== clickedSelectId) {
                    // Nastavíme tento select jako nepovinný a resetujeme jeho hodnotu na výchozí
                    $(this).prop('required', false).val($(this).find('option:first').val()).trigger('change');
                }
            });
        }
        
      
    }
    else{
        if($(this).closest('.parameterInner').find('img').length){
            var displayChoose = '<img src="'+$(this).closest('.parameterInner').find('img').attr('src')+'" alt="'+$(this).closest('.parameterInner').find('.textWrap span.name')+'">'
        }
        else{
            var displayChoose = ''
        }
        displayChoose += '<span class="textWrap">'+$(this).closest('.parameterInner').find('.textWrap').html()+'</span>'
        
        $(this).closest('.variantRow').find('h3 span.choosen').html(displayChoose)
        //$(this).closest('.chooseRow').find(".parameterInner:not([data-select-id='"+variantParameterId+"']):not([data-option-id='"+variantData+"'])").removeClass("active");
        $(this).closest('.chooseRow').find('.parameterInner').not($(this)).removeClass('active');
        $(this).closest('.parameterInner').addClass("active");
        $(this).closest('.variantRow').addClass('selected');
        $(this).closest('.variantRow').removeClass('openIt')
        $(this).closest('.variantRowGroup').removeClass('openIt')
        $(".product-top .detail-parameters select[data-parameter-id='"+variantParameterId+"'] option").filter(function (){return $(this).attr('value') == variantData }).change().prop("selected", true)
        $(".product-top .detail-parameters select[data-parameter-id='"+variantParameterId+"']")[0].dispatchEvent(new Event('change'));
        var selector = '.variant-list .hidden-split-parameter, .variant-list .split-parameter';
        var $splitParameters = $(selector);
        $splitParameters.trigger('change');
    }    

    setTimeout(function(){
        $('.configBottomLine .p-final-price-wrapper').html($('.p-info-wrapper>.p-final-price-wrapper').html())
        
    }, 250)

})


$(document).on('click', 'button.add-to-cart-button', function(e){
    var hasEmptySelect = false;
    $('.surcharge-list select[required="required"]').each(function() {
      if ($(this).val() === "") {
        hasEmptySelect = true;
        return false;
      }
    });
    if (hasEmptySelect) {
        e.preventDefault()
        showMessage("Položku nelze přidat do košíku. Vyberte prosím příplatkové parametry produktu.", 'error', '', false, false);
    }
})

$(document).on('click', '.configCenterLine .variantRow h3, .variantRowGroup h3', function(){
    $(this).closest('div').toggleClass('openIt')
})

/*
// Objekt konfigurace pro skupiny
var skupinyKonfigurace = {
    potahNaOperak: {
        class: 'customLineOperak',
        nadpis: 'Potah na opěrák',
        ids: ['40','43','46', '49', '52', '55', '58']
    },
    potahNaSedak: {
        class: 'customLineSedak',
        nadpis: 'Potah na sedák',
        ids: ['61','64','67', '70', '73', '76', '79']
    },
    potahNaZidle: {
        class: 'customLineSedak',
        nadpis: 'Potah na židli',
        ids: ['85','88','91', '94', '97', '100', '103', '106']
    },
    potahNaZidle2: {
        class: 'customLineSedak',
        nadpis: 'Potah na židli',
        ids: ['139','142','145', '148', '130', '133', '136', '151', '154', '157']
    }
    
};
var buttonText = 'Nakonfigurovat svůj originál'
var nadpisKonfiguratoru = 'Konfigurace'
var popisKonfiguratoru = 'Nakonfigurujte si svůj produkt přesně podle vašich představ.'
var nadpisPotahNaOperak = 'Zvolte si typ látky na opěrák'
var nadpisPotahNaSedak = 'Zvolte si typ látky na sedák'

*/